import log from '../../core/log';
// import waitForImages from 'jquery.waitforimages';
import { animate } from '../../core/animations';
import FilteringMenu from './FilteringMenu';
import { saveFilterState, applyFilterState, getSortingState, getPaginationState } from './filterState';
import productTileTemplate from './productTileTemplateNosto';
import keepSameHeightTitles from './keepSameHeightTitles';
import structuredData from './structuredData';
import NostoCollections from '../../components/nosto/collections';
import ShopifyCollection from '../../components/nosto/fallback';
// import applyShopifyMarket from '../../components/nosto/applyShopifyMarket';
// import loadProductsByID from '../../core/storefrontAPI/load-product-by-id';
// import loadCachedColorFamilies from '../../components/data-caching/loadCachedColorFamilies';
import SuggestionsSearch from '../../components/overlay-search-nosto/suggestions-search';
import { noResults, removeNoResults } from './noResults';
import recommendationListVisibility from './recommendationListVisibility';
import { removePlaceholders, removeMarketingBlocks, addPlaceholders, addMarketingBlocks, showPagination, initNumberedPagination, scrollToTile, refreshOptions, getSelectedFilters, removeProductTiles } from './actions';
import { updatePageInUrl } from './filterURL';

let fm = null;
let collection_handle = '';
let collection_id = 0;
let products_json = null;
let filtered_products = [];
let filtered_products_search = [];
let filtered_products_paginated = [];
let per_page = Number(window.theme.collections.products_per_page);
// ASTR pagination (different from the Nosto pagination that starts at 0)
let current_page = 1;
let current_page_search = 1;
let current_total_products_shown = 0;
let current_total_products_shown_search = 0;
let nosto_nbHits = 0;
let nosto_nbHits_search = 0;
let NostoCollectionsObj = null;
let ShopifyCollectionObj = null;

/* *** For search overlay ***/
const setFilteredProducts = (new_filtered_products) => {
  filtered_products_search = new_filtered_products;
};

const setNextPageSearch = (reset = false) => {
  current_page_search = (reset) ? 1 : current_page_search + 1;
};

const setNbHitsSearch = (new_nosto_nbHits_search) => {
  nosto_nbHits_search = new_nosto_nbHits_search;
};

const setCurrentPageSearch = (new_current_page_search) => {
  current_page_search = new_current_page_search;
  window.theme.search.page = current_page_search;
};

const getCurrentPageSearch = () => {
  return current_page_search;
};

const getCurrentPage = () => {
  return current_page;
};

/* *** End search overlay compatibility ****/

// We're not using regular pagination anymore since Algolia might send out of stock pinned products which we remove later from applyAvailabilityFilter() and we end up with less than per_page products
const getNextSetOfProducts = (page_reset = true, load_page = false) => {
  const from_search = document.body.classList.contains('has-overlay-search');
  // let total_pages = 1;
  // if (typeof load_page !== 'undefined') {
  //   total_pages = parseInt(load_page, 10);
  // }

  // const c_page = $('body').hasClass('has-overlay-search') ? current_page_search : current_page;
  const c_filtered_products = from_search ? filtered_products_search : filtered_products;
  let c_total_products_shown = 0;
  if (!page_reset) {
    c_total_products_shown = from_search ? current_total_products_shown_search : current_total_products_shown;
  }

  // const start = (c_page - 1) * per_page;
  // const end = (start + per_page) * total_pages;
  const start = c_total_products_shown;
  const end = c_filtered_products.length;
  if (from_search) {
    current_total_products_shown_search = c_filtered_products.length;
  } else {
    current_total_products_shown = c_filtered_products.length;
  }

  // log(current_page, start, end, per_page, load_page);
  // log('total returned', filtered_products.length);

  filtered_products_paginated = c_filtered_products.slice(start, end);

  log('getNextSetOfProducts', start, end, filtered_products_paginated, c_filtered_products.length);
};

/**
 * Build the product tiles from Nosto data and inject them to the grid
 * 
 * @param {boolean} append_content - If true, appends the content to the grid, otherwise replaces it
 * @param {boolean} from_search - If true, indicates that the function is called from the search overlay
 * @param {string} loading_type - The type of loading ('initial', 'initial-a', 'initial-b', 'filtering', 'pagination', 'search', 'search-pagination')
 *
 * @returns {Promise<void>} - Triggers 'astr-plp-tiles-built' event when complete
 */
const buildProductTiles = async (append_content, from_search = false, loading_type = '') => {
  return new Promise(async (resolve) => {
    if (!filtered_products_paginated.length) {
      resolve();
    }

    const prefix = (from_search) ? 'overlay-search-' : '';

    // Delay the loading until AB testing is ready if any
    if (typeof document.querySelector('.main-collection-section--settings')?.dataset.abReady !== 'undefined' && document.querySelector('.main-collection-section--settings')?.dataset.abReady === 'false' && typeof document.querySelector('.main-collection-section--settings')?.dataset.abTesting !== 'undefined') {
      // Poll until abReady is not 'false'
      const pollAbReady = () => {
        if (document.querySelector('.main-collection-section--settings')?.dataset.abReady !== 'false') {
          // Now safe to continue, give extra time for B experiment to fire
          window.setTimeout(() => {
            if (document.querySelector('.main-collection-section--settings')?.dataset.abTesting === '') {
              document.querySelector('.main-collection-section--settings').setAttribute('data-ab-testing', 'a');
            }
            buildProductTiles(append_content, from_search, loading_type).then(resolve);
          }, 250);
          
        } else {
          window.setTimeout(pollAbReady, 250);
        }
      };
      pollAbReady();
      return;
    }

    try {
      let start_increment = 0;

      // Build and render the 1st 5 product tiles for the 1st PLP page on initial load, then on a second call append the rest
      if (loading_type === 'initial-a') {
        filtered_products_paginated = filtered_products.slice(0, 5);
      } else if (loading_type === 'initial-b') {
        filtered_products_paginated = filtered_products.slice(5);
        start_increment = 5;
      }

      const products_tiles_html = filtered_products_paginated.map((product, idx) => {
        let tile_index = start_increment + idx + 1 + ((window.theme.collections.page - 1) * window.theme.collections.products_per_page);
        let tile_position = (window.theme.collections.page > 1) ? (start_increment + idx + 1 + ((window.theme.collections.page - 1) * per_page)) : null; // adding 1 because order is 0 based
        if (from_search) {
          tile_index = idx + 1 + ((window.theme.search.page - 1) * window.theme.search.products_per_page);
          tile_position = (window.theme.search.page > 1) ? (idx + 1 + ((window.theme.search.page - 1) * per_page)) : null;
        }

        return productTileTemplate(product, {
          is_slider: false,
          is_simplified: false,
          has_swatches: true,
          has_quickview: true,
          has_animations: (from_search || window.theme.breakpoints.current === 'mobile') ? false : true,
          is_search: from_search,
          is_lookbook: false,
          enable_price_conversion: true,
          tile_index,
          position: tile_position
        });
      }).join('');

      // const grid_container = (from_search) ? document.querySelector('[data-overlay-search-results] .grid') : document.querySelector('[data-product-tiles] .grid');

      // if (grid_container) {
      //   (append_content) ? grid_container.insertAdjacentHTML('beforeend', products_tiles_html) : grid_container.innerHTML = products_tiles_html;
      // }

      if (from_search) {
        const grid_container = document.querySelector('[data-overlay-search-grid-container] .grid');

        if (grid_container) {
          // (append_content) ? grid_container.insertAdjacentHTML('beforeend', products_tiles_html) : grid_container.innerHTML = products_tiles_html;
          grid_container.innerHTML = products_tiles_html;
          grid_container.querySelector('[data-total-filtered-items]')?.classList.remove('hide');
        }
      } else {
        const grid_container = document.querySelector('[data-product-tiles] .grid');

        if (grid_container) {
          if (append_content) {
            // Append the new product tiles
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = products_tiles_html;
            Array.from(tempDiv.childNodes).forEach(node => {
              grid_container.appendChild(node);
            });
          } else {
            removePlaceholders();
            removeMarketingBlocks();
            removeProductTiles();

            const total_filtered_items = grid_container.querySelector('[data-total-filtered-items]');
            if (total_filtered_items) {
              total_filtered_items.classList.remove('hide');
            }

            grid_container.insertAdjacentHTML('beforeend', products_tiles_html);
          }
        }
      }

      // await applyShopifyMarket((from_search) ? '[data-overlay-search-results]' : '[data-collection-grid-container]');
    } catch (error) {
      log(error);
    }

    const mobile_filter_nav = (from_search) ? document.querySelector('[data-overlay-search] [data-show-mobile-filter-nav]') : document.querySelector('[data-collection-grid-container] [data-show-mobile-filter-nav]');
    if (mobile_filter_nav) {
      mobile_filter_nav.classList.add('active');
      mobile_filter_nav.parentElement?.classList.add('active');
    }

    // const from_search = document.body.classList.contains('has-overlay-search');

    // Preselect the recommended color or 1st color swatch
    const tile_selector = from_search ? '[data-overlay-search-grid-container] [data-product-tile]' : '[data-collection-grid-container] [data-product-tile]';
    const init_tiles = Array.from(document.querySelectorAll(tile_selector)).filter(tile => !tile.classList.contains('init'));

    init_tiles.forEach(tile => {
      const color_swatch = tile.querySelectorAll('[data-color-swatch]');
      if (color_swatch.length > 0) {
        color_swatch[0].click();
      }
      tile.classList.add('init');
    });

    try {
      keepSameHeightTitles();
      animate();
      // updateLoadMoreButton();
      initNumberedPagination(nosto_nbHits_search, nosto_nbHits);
    } catch (error) {
      log(error);
    }

    // Dispatch events for new functionalities (init video tiles, etc.)
    const tiles_built_event = new CustomEvent('astr-plp-tiles-built', { bubbles: true });
    tiles_built_event.data = { from_search, filtered: ($(`[data-${prefix}selected-filters-item]`).length > 0) };
    document.dispatchEvent(tiles_built_event);

    resolve();
  });
};

/**
 * Load the original collection data. Either on first call or when a sorting event occurs
 * 
 * @param {boolean} is_sorting_event - If true, indicates that the function is called from a sorting event
 * 
 * @returns {Promise<void>} - Resolves when the collection is loaded
 */
const loadCollection = async (is_sorting_event = false) => {
  try {
    console.log('[ASTR] loadCollection', collection_handle, is_sorting_event);
    if (collection_handle === null || !collection_handle.length) {
      return;
    }

    const from_search = document.body.classList.contains('has-overlay-search');

    // Remove the "No results" div if present
    removeNoResults();

    // Page is always 1 when we trigger a sorting event (select new sort option)
    if (is_sorting_event) {
      if (from_search) {
        current_page_search = 1;
        window.theme.search.page = current_page_search;
      } else {
        current_page = 1;
        window.theme.collections.page = current_page;
        updatePageInUrl(current_page);
      }
    }

    // if (!window.theme.collections.page_split) {
      if (from_search) {
        const overlaySearchGridContainer = document.querySelector('[data-overlay-search-grid-container] .grid');
        if (overlaySearchGridContainer) {
          overlaySearchGridContainer.innerHTML = '';
        }
      } else {
        const collectionGridContainer = document.querySelector('[data-collection-grid-container] [data-show-mobile-filter-nav]');
        if (collectionGridContainer) {
          collectionGridContainer.classList.remove('active');
        }
      
        /*
        // We will just remove the product placeholders when the data is ready to be rendered
        const productTilesGrid = document.querySelector('[data-product-tiles] .grid');
        if (productTilesGrid) {
          productTilesGrid.innerHTML = '';
        }
        */
      
        const totalFilteredItems = document.querySelector('[data-total-filtered-items]');
        if (totalFilteredItems) {
          totalFilteredItems.classList.add('hide');
        }
      }
    // }

    window.theme.collections.sorting = getSortingState(true);

    // This function also gets called after selecting a new sorting option and filtering options might have been selected already
    // Extract the selected filter options
    const selected_filtering = getSelectedFilters();

    // Set the page from the URL if present
    const urlParams = new URLSearchParams(window.location.search);
    const pageFromUrl = (from_search) ? parseInt(urlParams.get('spage'), 10) : parseInt(urlParams.get('page'), 10);

    if (from_search) {
      // window.theme.search.page = 1;
      window.theme.search.filtering = selected_filtering;
    } else {
      // window.theme.collections.page = 1;
      window.theme.collections.filtering = selected_filtering;
    }

    window.theme.collections.page = (!isNaN(pageFromUrl) && pageFromUrl > 0) ? pageFromUrl : 1;

    removeProductTiles();
    addPlaceholders();
    addMarketingBlocks();

    log('[ASTR] Initial Sorting:', window.theme.collections.sorting);
    log('[ASTR] Initial Filtering:', selected_filtering);

    const nosto_collection = (window.theme.api.nosto.collection.enabled === true) ? await NostoCollectionsObj.nostoRequest() : await ShopifyCollectionObj.shopifyRequest();
    // console.log('nosto_collection 2: ', nosto_collection);
    let nosto_products = [];

    if (typeof nosto_collection !== 'undefined' && nosto_collection !== null && typeof nosto_collection.products !== 'undefined' && nosto_collection.products !== null && nosto_collection.products.hits !== null && nosto_collection.products.hits.length > 0) {
      nosto_products = nosto_collection.products.hits;
    }

    const start_rendering = new Date();

    products_json = nosto_products;

    // We're on a collection page and a 3rd level URL is set (e.g. /collections/dresses/red)
    // Redirect to parent collection if we get less than 10 products
    if (window.localStorage.getItem('wild-third-level-url') !== null) {
      if (products_json === null || products_json.length < 10) {
        window.location.href = `/collections/${collection_handle}`;
        return;
      }
    }

    // No results
    if (products_json === null || products_json.length === 0) {
      noResults();
      refreshOptions(0);
      initNumberedPagination(nosto_nbHits_search, nosto_nbHits);

      // Hide the filters
      document.querySelector('.collection-grid-section')?.classList.add('no-results');

      document.querySelectorAll('[data-collection-grid-container] [data-show-mobile-filter-nav]').forEach(el => {
        el.style.display = 'none';
      });

      if (document.querySelector('[data-change-grid]')) {
        document.querySelectorAll('[data-change-grid-parent]').forEach(el => {
          el.style.display = 'none';
        });
      }

      return;
    }

    showPagination();

    window.theme.collections.facets = nosto_collection.products.facets ?? [];

    // getNextSetOfProducts(true);
    filtered_products = products_json;

    // Build the filter menu
    if (fm === null && window.theme.collections.facets.length > 0) {
      fm = new FilteringMenu();
      document.querySelectorAll('[data-filters-panel-v2]').forEach(el => {
        el.classList.add('loaded');
      });
    }

    if (filtered_products.length) {
      getNextSetOfProducts(true);

      if (from_search) {
        await buildProductTiles(false, from_search, 'initial');
      } else {
        await buildProductTiles(false, from_search, 'initial-a');
        window.setTimeout(async () => {
          await buildProductTiles(true, from_search, 'initial-b');
        }, 10);
      }

      showPagination();
    } else {
      noResults();
    }

    if (from_search) {
      nosto_nbHits_search = nosto_collection.products.total;
      initNumberedPagination(nosto_nbHits_search, nosto_nbHits);
    } else {
      structuredData(nosto_collection?.products?.hits || []);

      nosto_nbHits = nosto_collection.products.total;
      refreshOptions(nosto_nbHits);
      initNumberedPagination(nosto_nbHits_search, nosto_nbHits);

      // When coming back from a product page, or filtering querystring is in URL - ONLY
      // Note: this will re-trigger a Nosto API event. This is needed if we want to keep the same filter data from the original request.
      await applyFilterState(true);
      window.setTimeout(() => { scrollToTile(false); }, 100);
    }

    const end_rendering = new Date() - start_rendering;
    log(`Data rendered in ${end_rendering / 1000} seconds`);
  } catch (error) {
    console.log('[ASTR] loadCollection()', error);
  }
};

/**
 * Select a new filter from the nav
 * force_per_page used when coming back from the PDP
 * 
 * @param {boolean} save_filter_state - If true, saves the filter state
 * @param {number} saved_page - The page to load, used when coming back from the PDP
 * @param {string} force_sorting - The sorting option to use, if any
 * 
 * @returns {Promise<void>} - Resolves when the new filter is applied
 */
const selectNewFilter = async (save_filter_state = true, force_sorting = '', saved_page) => {
  console.log('[ASTR] selectNewFilter', save_filter_state, force_sorting, saved_page);
  const from_search = document.body.classList.contains('has-overlay-search');
  const prefix = (from_search) ? 'overlay-search-' : '';
  const is_save_filter_state = (from_search) ? false : save_filter_state;

  if (from_search) {
    current_page_search = 1;
    window.theme.search.page = current_page_search;
  } else {
    current_page = 1;
    window.theme.collections.page = current_page;
  }

  if (is_save_filter_state) {
    saveFilterState();
  }

  removeNoResults();

  if (!from_search && typeof saved_page !== 'undefined') {
    log(`[wild-filter] saved_page: ${saved_page}`);
    current_page = saved_page;

    if (current_page <= 0) {
      current_page = 1;
    }

    window.theme.collections.page = current_page;
  }

  if (!from_search) {
    updatePageInUrl(current_page);
  }

  // Extract the selected options
  const selected_filtering = getSelectedFilters();

  // Restore the sort by state
  if (force_sorting === '') {
    document.querySelector(`[data-${prefix}sort-by] [data-value="${window.theme.collections.sorting}"] input`).checked = true;
    document.querySelector(`[data-mobile-${prefix}filter-sorting] [data-value="${window.theme.collections.sorting}"] input`).checked = true;
  }

  recommendationListVisibility(selected_filtering);

  const grid_container = (from_search) ? document.querySelector('[data-overlay-search-grid-container] .grid') : document.querySelector('[data-product-tiles] .grid');

  // Load the 1st page of Nosto data. It will be used as reference.
  let nosto_collection = null;

  if (from_search) {
    window.theme.search.filtering = selected_filtering;
    window.theme.search.page = 1;

    if (grid_container) {
      grid_container.innerHTML = '';
    }

    const suggestionsSearch = new SuggestionsSearch();
    await suggestionsSearch.nostoSearch(true);
    return;
  } else {
    window.theme.collections.filtering = selected_filtering;

    removeProductTiles();
    addPlaceholders();
    addMarketingBlocks(); // we might need them after clearing the filters

    nosto_collection = (window.theme.api.nosto.collection.enabled === true) ? await NostoCollectionsObj.nostoRequest() : await ShopifyCollectionObj.shopifyRequest();
    // console.log('nosto_collection 1: ', nosto_collection);
  }

  let nosto_products = [];

  if (typeof nosto_collection === 'undefined' || nosto_collection === null || typeof nosto_collection.products === 'undefined' || nosto_collection.products === null || nosto_collection.products.hits === null || nosto_collection.products.hits.length === 0) {
    // if (from_search) {
    //   filtered_products_search = [];
    // } else {
      filtered_products = [];
    // }
    
    refreshOptions(0);
    initNumberedPagination(nosto_nbHits_search, nosto_nbHits);
  } else {
    nosto_products = nosto_collection.products.hits;

    // Load the same products from the Storefront API
    // const unique_ids = _.uniq(nosto_products.map(hit => hit.id));
    // const storefrontapi_products = await loadProductsByID(unique_ids);

    // log('-- Total Storefront API products:', storefrontapi_products.length);
    // log('-- Total Nosto hits:', nosto_products.length);

    // filtered_products = mergeStorefrontAPIAndAlgoliaData(storefrontapi_products, nosto_products);
    if (from_search) {
      nosto_nbHits_search = nosto_collection.products.total;
    } else {
      nosto_nbHits = nosto_collection.products.total;
      refreshOptions(nosto_nbHits);
      initNumberedPagination(nosto_nbHits_search, nosto_nbHits);
    }
  }

  if (from_search) {
    filtered_products_search = nosto_products;
  } else {
    filtered_products = nosto_products;
  }

  const mobile_filter_nav = document.querySelector('[data-collection-grid-container] [data-show-mobile-filter-nav]');
  if (mobile_filter_nav) {
    mobile_filter_nav.classList.add('active');
  }

  const total_filtered_items = document.querySelector('[data-total-filtered-items]');
  if (total_filtered_items) {
    total_filtered_items.classList.remove('hide');
  }

  const c_filtered_products = (from_search) ? filtered_products_search : filtered_products;

  if (c_filtered_products.length) {
    // Show the correct amount of products
    if (is_save_filter_state === false && !from_search) {
      const load_page = getPaginationState();
      getNextSetOfProducts(true, load_page);
      current_page = load_page;
    } else {
      getNextSetOfProducts(true);
    }

    await buildProductTiles(false, from_search, 'filtering');
    showPagination();
  } else {
    noResults();
  }

  scrollToTile(is_save_filter_state);

  if (per_page > window.theme.collections.products_per_page) {
    current_page = per_page / window.theme.collections.products_per_page;
    per_page = window.theme.collections.products_per_page;
  }
};

/**
 * Request the new page data (From numbered pagination or load more)
 * Adds the products to the filtered_products variable
 *
 * @param {Boolean} regular_pagination - Numbered pagination if true; Load more if false
 *
 * @returns {Boolean} false if no Nosto products extracted. true otherwise
 * 
 */
const loadPageData = async (regular_pagination = false) => {
  console.log('[ASTR] loadPageData', regular_pagination);
  const from_search = document.body.classList.contains('has-overlay-search');

  // Empty the page
  const grid_container = (from_search) ? document.querySelector('[data-overlay-search-grid-container] .grid') : document.querySelector('[data-product-tiles] .grid');
  if (grid_container) {
    // grid_container.innerHTML = '';
    removeProductTiles();

    // Re-inject the placeholder while we're loading the new products
    addPlaceholders();

    // Re-inject the marketing blocks while we're loading the new products if needed (page 1, no sort, no filters, no color in url, not from search overlay...)
    // If the marketing blocks were already injected, and the conditions are met, we remove them
    addMarketingBlocks();
  }
  window.scrollTo({ top: 0, behavior: 'auto' });

  const container_selector = from_search ? document.querySelector('[data-overlay-search-results]') : document.querySelector('[data-product-tiles]');
  if (container_selector) {
    const pagination_element = container_selector.querySelector('[data-pagination]');
    if (pagination_element) {
      pagination_element.classList.remove('disabled');
    }
  }

  // Extract the selected filter options
  const selected_filtering = getSelectedFilters();
  if (from_search) {
    window.theme.search.filtering = selected_filtering;
  } else {
    window.theme.collections.filtering = selected_filtering;
  }

  /*
  // Load and add the next set of Algolia products to filtered_products
  const nosto_collection = await loadAlgoliaCollection(current_page - 1, selected_filtering);
  let nosto_products = [];

  if (nosto_collection === null || typeof nosto_collection.hits === 'undefined' || nosto_collection.hits.length === 0) {
    return false;
  }

  // Merge the cached data and the Algolia data if we received data from Algolia
  nosto_products = nosto_collection.hits;

  // Load the same products from the Storefront API
  const unique_ids = _.uniq(nosto_products.map(hit => hit.id));
  const storefrontapi_products = await loadProductsByID(unique_ids);

  const new_set_of_filtered_products = mergeStorefrontAPIAndAlgoliaData(storefrontapi_products, nosto_products);
  */

  const nosto_collection = (window.theme.api.nosto.collection.enabled === true) ? await NostoCollectionsObj.nostoRequest() : await ShopifyCollectionObj.shopifyRequest();
  let nosto_products = [];
  // console.log('nosto_collection 3: ', nosto_collection);
  if (typeof nosto_collection === 'undefined' || nosto_collection === null || typeof nosto_collection.products === 'undefined' || nosto_collection.products === null || nosto_collection.products.hits === null || nosto_collection.products.hits.length === 0) {
    return false;
  }

  nosto_products = nosto_collection.products.hits;

  if (regular_pagination) {
    filtered_products_paginated = nosto_products;
    filtered_products = nosto_products;
  } else {
    filtered_products = filtered_products.concat(nosto_products);
  }
  
  // log('[ASTR] -- Total Storefront API products:', storefrontapi_products.length);
  log('[ASTR] -- Total Nosto hits in page:', nosto_products.length);
  log('[ASTR] -- Total filtered products:', filtered_products.length);

  if (!from_search) {
    recommendationListVisibility(selected_filtering);
  }

  return true;
};

/**
 * Init the events for some of the elements within the PLP
 */
const initEvents = () => {
  /*
  // Load more for PLP only (not search overlay)
  document.addEventListener('click', async (e) => {
    if (e.target.matches('[data-load-more]')) {
      e.preventDefault();
      e.stopPropagation();
      const item = e.target;

      if (item.classList.contains('loading')) {
        return;
      }

      const from_search = document.body.classList.contains('has-overlay-search');
      item.innerHTML = 'Loading...';
      item.classList.add('loading');
      current_page++;
      (from_search) ? window.theme.search.page = current_page : window.theme.collections.page = current_page;
      saveFilterState();

      window.trigger_on_more_page = true;

      await loadPageData();
      getNextSetOfProducts(false);
      buildProductTiles(true, false);

      if (filtered_products_paginated.length < per_page) {
        const load_more_button = document.querySelector('[data-load-more]');
        if (load_more_button) {
          load_more_button.classList.add('hide');
        }
      }

      // [ADA] Focus new element, do not place the focus to the main element, it would enable the add to cart / quickview button
      // const last_tile_index = per_page * (current_page - 1);
      // document.querySelectorAll('[data-product-tile] [data-product-tile-image]')[last_tile_index].focus();
    }
  });
  */

  /* ********************************************
  Numbered pagination PLP only (not search overlay)
  ******************************************** */
  // Helper function to handle pagination clicks
  const handlePaginationClick = async (item, pageChange, explicitPage = null) => {
    if (item.classList.contains('disabled')) {
      return;
    }

    const from_search = document.body.classList.contains('has-overlay-search');
    const previous_page = window.theme.collections.page;
    let new_page;
    if (explicitPage !== null) {
      new_page = explicitPage;
    } else {
      new_page = (from_search) ? window.theme.search.page + pageChange : window.theme.collections.page + pageChange;
    }
    const total_pages = Math.ceil(nosto_nbHits / per_page);
    new_page = Math.max(1, Math.min(new_page, total_pages));
    (from_search) ? window.theme.search.page = new_page : window.theme.collections.page = new_page;
    current_page = new_page;
    window.theme.collections.cursor_direction = (new_page >= previous_page) ? 'after' : 'before';
    // console.log('[ASTR] Pagination click, new page:', new_page, ' previous_page:', previous_page, ' total_pages:', total_pages, ' direction:', window.theme.collections.cursor_direction);

    updatePageInUrl(new_page);
    saveFilterState();
    await loadPageData(true);
    await buildProductTiles(false, false, 'pagination');
    initNumberedPagination(nosto_nbHits_search, nosto_nbHits);

    // [ADA] Focus new element
    document.querySelector('[data-product-tiles] [data-product-tile]')?.focus();
  };

  document.addEventListener('click', async (e) => {
    const target = e.target.closest('[data-pagination-first], [data-pagination-last], [data-pagination-next], [data-pagination-previous]');
    if (!target) return;

    if (target.matches('[data-pagination-first]')) {
      await handlePaginationClick(target, 0, 1);
    } else if (target.matches('[data-pagination-last]')) {
      const total_pages = Math.ceil(nosto_nbHits / per_page);
      await handlePaginationClick(target, 0, total_pages);
    } else if (target.matches('[data-pagination-next]')) {
      await handlePaginationClick(target, 1);
    } else if (target.matches('[data-pagination-previous]')) {
      await handlePaginationClick(target, -1);
    }

    window.localStorage.setItem('current-page', window.location.href);
  });

  /*
  // Might not be the best place to add but this is for PLP and Search overlay
  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-product-tile-image]')) {
      const item = e.target;
      const tile = item.closest('.product-tile');
      // algoliaSearchClickEvent([String(tile.dataset.productAlgoliaId)], [tile.closest('.product-tile').index() + 1]);
    }
  });
  */
};

/**
 * Initialize the events and data for filtering
 */
const initFiltering = async () => {
  try {
    // Validate and retrieve collection data
    const collection_grid = document.querySelector('[data-collection-grid]');
    if (!collection_grid) {
      throw new Error('Collection grid element not found.');
    }

    collection_handle = collection_grid.dataset.collection || '';
    collection_id = collection_grid.dataset.collectionId || '';

    if (!collection_handle || !collection_id) {
      throw new Error('Collection handle or ID is missing.');
    }

    // Initialize NostoCollections object
    if (window.theme.api.nosto.collection.enabled === true) {
      NostoCollectionsObj = new NostoCollections(collection_id);
      if (!NostoCollectionsObj) {
        throw new Error('Failed to initialize NostoCollections.');
      }
    } else {
      ShopifyCollectionObj = new ShopifyCollection(collection_id, true);
      if (!ShopifyCollectionObj) {
        throw new Error('Failed to initialize ShopifyCollection.');
      }
    }

    // Initialize events and load collection data
    initEvents();
    await loadCollection();
  } catch (error) {
    console.error('[initFiltering] Error initializing filtering:', error);
  }
};

export {
  initFiltering,
  selectNewFilter,
  products_json,
  filtered_products,
  filtered_products_search,
  buildProductTiles,
  setFilteredProducts,
  setNextPageSearch,
  setNbHitsSearch,
  setCurrentPageSearch,
  getCurrentPageSearch,
  getCurrentPage,
  getNextSetOfProducts,
  getSelectedFilters,
  per_page,
  loadCollection,
};
